import { render, staticRenderFns } from "./SignupWizardStepAddArtist.vue?vue&type=template&id=bc69f4ac&scoped=true&"
import script from "./SignupWizardStepAddArtist.vue?vue&type=script&lang=js&"
export * from "./SignupWizardStepAddArtist.vue?vue&type=script&lang=js&"
import style0 from "./SignupWizardStepAddArtist.vue?vue&type=style&index=0&id=bc69f4ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc69f4ac",
  null
  
)

export default component.exports